import Mainvisual from "../top/mainvisual";
export default class Switch {
    constructor() {
        this.Mainvisual = new Mainvisual();
        this.init();
    }

    init() {
        this.isThemaColor = STORAGE.data.ThemaColor;

        this.setThema();
        this.toggleThema();
    }

    toggleThema() {
        const movieBtn = [...document.querySelectorAll(".js-toggle-thema")];

        movieBtn.forEach((el) => {
            el.addEventListener("click", (e) => {
                e.preventDefault();
                const thema = STORAGE.data.ThemaColor;

                if (thema === "makyou") {
                    STORAGE.set("ThemaColor", "tengoku");
                    document.body.classList.remove("-makyou");
                    document.body.classList.add("-tengoku");
                } else {
                    STORAGE.set("ThemaColor", "makyou");
                    document.body.classList.remove("-tengoku");
                    document.body.classList.add("-makyou");
                    this.Mainvisual.resetKv();
                }

                this.serCurtain();
            });
        });
    }

    setThema() {
        window.addEventListener("DOMContentLoaded", () => {
            const thema = STORAGE.data.ThemaColor;

            if (thema === "makyou") {
                this._setBackground(thema);

                if (document.body.classList.contains("-tengoku")) {
                    document.body.classList.remove("-tengoku");
                }

                document.body.classList.add("-makyou");
                
            } else {
                this._setBackground(thema);

                if (document.body.classList.contains("-makyou")) {
                    document.body.classList.remove("-makyou");
                }
                document.body.classList.add("-tengoku");
            }

            this.Mainvisual.init();
        });
    }

    serCurtain() {
        const change = document.querySelector(".js-change");
        document.body.classList.add("is-change");

        const changeend = document.querySelector(".js-change-end");

        changeend.addEventListener("animationend", () => {
            document.body.classList.remove("is-change");
        });
    }

    _setBackground(thema) {
        var color = thema === "makyou" ? "#000" : "#fff";
        document.body.style.backgroundColor = color;
    }
}
